/* =========================================================
   Starterset / Bundle Script
   FULL FUNCTIONALITY PRESERVED + OPTIMIZED
   - Slot fill = first empty
   - Auto append when all filled
   - set_id restore works
   - Free items logic preserved
   - No polling (progress updates event-driven)
   - Event delegation (fast)
========================================================= */
(function () {
  "use strict";

  /* -------------------------------
     Guards
  -------------------------------- */
  const OVERLAY = document.querySelector("#nailsoverlay");
  //if (!OVERLAY) return;

  /* -------------------------------
     DOM CACHE (stable)
  -------------------------------- */
  const DOM = {
    overlay: OVERLAY,
    overlayWrapper: OVERLAY?.querySelector(".colorModel-wrapper"),
    mainWrapper: document.querySelector(".colorModel-wrapper.main"),
    progress: OVERLAY?.querySelector(".progress-bar .progress"),
    addOverlayBtn: document.querySelector(".add-in-overlay"),
    slider: document.querySelector("#slider"),
    tabImages: [...document.querySelectorAll(".tab-images .starterset-product")],
  };

  /* -------------------------------
     Page context flags (stable)
  -------------------------------- */
  const pageFlags = {
    isPromotedProduct: !!document.querySelector(
      '[data-product-handle="starterset-mothers-day-3-free-manicures"]'
    ),
    isStarterSet: !!document.querySelector(".template--product-starterset"),
    isSpecialBundle: !!document.querySelector(".template--product-special-bundle"),
    isStarterSpecialBundle: !!document.querySelector(".template--product-starterset-special-bundle"),
    isStarterSpecialBigBundle: !!document.querySelector(".template--product-starterset-special-big-bundle"),
  };

  /* -------------------------------
     Cart buttons selector (your original)
  -------------------------------- */
  const cartButtons = [
    ...document.querySelectorAll(
      "[data-product-handle='starterset-mothers-day-3-free-manicures'] product-sticky-form #StickyAddToCart, " +
        "[data-product-handle='starterset-mothers-day-3-free-manicures'] product-payment-container #AddToCart," +
        ".template--product-starterset product-payment-container #AddToCart," +
        ".template--product-starterset product-sticky-form #StickyAddToCart, " +
        ".template--product-special-bundle product-payment-container #AddToCart," +
        ".template--product-special-bundle product-sticky-form #StickyAddToCart, " +
        ".template--product-starterset-special-bundle product-payment-container #AddToCart," +
        ".template--product-starterset-special-bundle product-sticky-form #StickyAddToCart, " +
        ".template--product-starterset-special-big-bundle product-payment-container #AddToCart," +
        ".template--product-starterset-special-big-bundle product-sticky-form #StickyAddToCart"
    ),
  ];

  /* -------------------------------
     Product state
     productDATA[index-1] = { index, image, variant, price, title }
     null means empty slot
  -------------------------------- */
  let productDATA = [];

  /* -------------------------------
     Helpers
  -------------------------------- */
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const $ = (sel, root = document) => root.querySelector(sel);

  // Localised copy, set by snippets/starterset.liquid from the locale files. The English
  // fallbacks only apply if the snippet did not render, which is also the only case where
  // this script has nothing to drive.
  const STRINGS = window.startersetStrings || {};
  const t = (key, fallback, replacements) => {
    let out = STRINGS[key] || fallback;
    for (const token in replacements) out = out.replace(token, replacements[token]);
    return out;
  };

  function limitWords(input, maxWords = 1) {
    const words = String(input || "").trim().split(/\s+/);
    const kept = words.slice(0, maxWords);
    if (kept.length >= 2 && kept[1].toLowerCase() === "by") kept.splice(1, 1);
    return kept.join(" ");
  }

  function getDiscountPercent() {
    // exactly your original
    if (document.querySelector(".template--product-starterset-special-bundle") != null) return 10;
    if (document.querySelector(".template--product-starterset-special-big-bundle") != null) return 20;
    return 15;
  }

  function getFreeAllowance() {
    // exactly your original logic (special bundle=5, promoted=3, else=2)
    if (pageFlags.isSpecialBundle) return 5;
    if (pageFlags.isPromotedProduct) return 3;
    return 2;
  }

  function getRequiredCountForATC() {
    // your original gate logic (based on itemsToAdd length incl default product)
    // For UI text, we base it on chosen add-on count threshold:
    // - starterset special big bundle needs 7 addons (then + default = 8 items)
    // - starterset special bundle needs 3 addons (then + default = 4 items)
    // - special bundle needs 5 addons (then + default = 6 items)
    // - promoted needs 3 addons (then + default = 4 items)
    // - normal needs 2 addons (then + default = 3 items)
    if (pageFlags.isStarterSpecialBigBundle) return 7;
    if (pageFlags.isStarterSpecialBundle) return 3;
    if (pageFlags.isSpecialBundle) return 5;
    if (pageFlags.isPromotedProduct) return 3;
    return 2;
  }

  // Minimum number of chosen designs before the overlay "Next" button may proceed.
  // These mirror the real add-to-cart gates in attachCartButtonHandlers (and equal
  // the "X out of N selected" counter shown to the customer), so Next enables exactly
  // when the cart would actually accept the set.
  function getMinDesigns() {
    if (pageFlags.isStarterSpecialBigBundle) return 8;
    if (pageFlags.isStarterSpecialBundle) return 4;
    if (pageFlags.isSpecialBundle) return 5;
    if (pageFlags.isPromotedProduct) return 3;
    return 2;
  }

  // Toggle the overlay "Next" button between enabled and a visible-but-unclickable
  // disabled state, based on how many designs are selected. Prevents rage clicks on a
  // Next button that silently does nothing below the minimum. The "Close" button
  // (.nails-close-btn) is intentionally never touched.
  function updateNextButtonState() {
    const selected = productDATA.filter(Boolean).length;
    const min = getMinDesigns();
    const enabled = selected >= min;
    document.querySelectorAll(".right-svg.close.next-btn").forEach((btn) => {
      btn.classList.toggle("is-disabled", !enabled);
      btn.setAttribute("aria-disabled", (!enabled).toString());

      // Below the minimum the label states the shortfall instead of reading "Next",
      // so a disabled button explains itself rather than looking broken.
      const label = btn.querySelector(".next-btn__label");
      if (label) {
        label.textContent = enabled
          ? t("next", "Next")
          : t("pickMore", "Pick [count] more", { "[count]": min - selected });
      }
    });
  }

  function currentSlotCount() {
    return $$("#nailsoverlay [data-index]").length;
  }

  function ensureProductDataLength() {
    const total = currentSlotCount();
    if (productDATA.length < total) {
      productDATA.length = total;
      for (let i = 0; i < total; i++) {
        if (typeof productDATA[i] === "undefined") productDATA[i] = null;
      }
    }
  }

  function buildToAppendBoxHTML() {
    const percent = getDiscountPercent();
    return `<div class="chooseColor-wrapper empty">
      <div data-index="1" data-image="//maniac-nails.com/cdn/shop/t/123/assets/nails-30-30.png?v=12479623064242345351712382408" class="chooseColor staterset active coladded">
        <div class="badge product-meta__label-list label-list">
          <span class="label label--highlight">-${percent}%</span>
        </div>
        <div class="color-selection__arrow discounted_close_svg close_icon_svg">
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <path d="M13.8674 4.62158L4.62241 13.8666" stroke="#272727" stroke-opacity="0.6" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M4.62256 4.62158L13.8676 13.8666" stroke="#272727" stroke-opacity="0.6" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
        <img src="//maniac-nails.com/cdn/shop/t/123/assets/nails-30-30.png?v=12479623064242345351712382408" alt="">
      </div>
      <p style="text-align: start;margin: 5px;font-size: small;"></p>
    </div>`;
  }

  /* -------------------------------
     Append box (preserves your behavior)
  -------------------------------- */
  function appendBox() {
    document.querySelectorAll(".colorModel-wrapper").forEach(function (elem) {
      const targetElement = elem.querySelector(".ps-picker__display")?.closest(".button");
      if (!targetElement) return;

      const container = document.createElement("div");
      container.innerHTML = buildToAppendBoxHTML();
      const newElement = container.firstChild;

      const elementIndex = currentSlotCount(); // after existing
      newElement.querySelector(".chooseColor").dataset.index = elementIndex + 1;

      targetElement.parentNode.insertBefore(newElement, targetElement);
    });

    ensureProductDataLength();
    requestAnimationFrame(() => {
      updateProgress();
      updateCartButtonText();
    });
  }

  /* -------------------------------
     Slot fill (first empty) – this is your real behavior
  -------------------------------- */
  // Returns the overlay slot it filled (null if the tray was already full), so the
  // caller can animate the chosen design into that exact slot.
  function fillFirstEmptySlot(productHASH) {
    ensureProductDataLength();

    // fill in overlay slots
    let filledSlot = null;
    const overlaySlots = $$("#nailsoverlay [data-index]");
    for (const slot of overlaySlots) {
      if (!slot.dataset.exist && !filledSlot) {
        const idx = Number(slot.dataset.index);
        productDATA[idx - 1] = productHASH;

        slot.classList.add("coladded", "filled");
        slot.dataset.exist = "true";
        slot.dataset.price = productHASH.price;
        slot.dataset.variant = productHASH.variant;

        const imgEl = slot.querySelector("img");
        if (imgEl) imgEl.src = productHASH.image;

        const p = slot.closest(".chooseColor-wrapper")?.querySelector("p");
        if (p) p.innerText = limitWords(productHASH.title);

        filledSlot = slot;
        break;
      }
    }

    // mirror into main wrapper slots
    let didFillMain = false;
    if (DOM.mainWrapper) {
      const mainSlots = $$("[data-index]", DOM.mainWrapper);
      for (const slot of mainSlots) {
        if (!slot.dataset.exist && !didFillMain) {
          slot.classList.add("coladded");
          slot.dataset.exist = "true";
          slot.dataset.price = productHASH.price;
          slot.dataset.variant = productHASH.variant;

          const imgEl = slot.querySelector("img");
          if (imgEl) imgEl.src = productHASH.image;

          const p = slot.closest(".chooseColor-wrapper")?.querySelector("p");
          if (p) p.innerText = limitWords(productHASH.title);

          didFillMain = true;
          break;
        }
      }
    }

    // mark added on tab images
    syncTabBadges();

    requestAnimationFrame(() => {
      updateProgress();
      adjustPrice();
      updateCartButtonText();
    });

    return filledSlot;
  }

  function allSlotsAreColadded() {
    const slots = $$("#nailsoverlay [data-index]");
    return slots.length > 0 && slots.every((s) => s.classList.contains("coladded"));
  }

  function checkLimit() {
    const limit = 10;
    ensureProductDataLength();

    const slots = $$("#nailsoverlay [data-index]");
    const length = slots.length;

    const allFilled = slots.every((s) => s.classList.contains("filled"));
    const addButtons = $$(".colorModel-wrapper a.button");

    // button text logic based on real selected count
    updateCartButtonText();

    if (limit === length && allFilled === true) {
      addButtons.forEach((b) => b.classList.add("hidden"));
      alert(t("maxReached", "Maximum limit of [limit] boxes reached, cannot add more.", { "[limit]": limit }));
      return false;
    } else {
      addButtons.forEach((b) => b.classList.remove("hidden"));
      return true;
    }
  }

  function updateCartButtonText() {
    ensureProductDataLength();
    const filtered = productDATA.filter(Boolean);
    const required = getRequiredCountForATC();

    cartButtons.forEach((btn) => {
      const cartTxt = document.querySelector("[data-atc-text]");
      const label =
        filtered.length >= required
          ? t("addToCart", "Add to cart")
          : cartTxt
            ? cartTxt.getAttribute("data-atc-text")
            : t("chooseColors", "Choose your colors");
      const node = btn.querySelector(".loader-button__text") || btn.querySelector("span");
      if (node) node.innerHTML = label;
      btn.disabled = false;
    });

    // Keep the overlay Next button in sync on every state change (fill/remove/append/restore/init).
    updateNextButtonState();
  }

  function updateProgress() {
    const slots = $$("#nailsoverlay [data-index]");
    const total = slots.length || 1;
    const filled = slots.filter((s) => s.classList.contains("filled")).length;
    const pct = (filled / total) * 100;
    if (DOM.progress) DOM.progress.style.width = `${pct}%`;
  }

  // Stamps each grid tile with its tray slot number (data-slot) and the .added state,
  // both derived from productDATA. The number ties a tile to its slot in the tray, so the
  // customer can see which designs are theirs — and in what order — without looking away
  // from the grid. CSS draws the number from the attribute; removing it clears the badge.
  // A design picked into several slots shows its first, matching the leftmost tray slot.
  function syncTabBadges() {
    const slotByVariant = new Map();
    productDATA.forEach((p, i) => {
      const key = p && String(p.variant);
      if (key && !slotByVariant.has(key)) slotByVariant.set(key, i + 1);
    });

    document.querySelectorAll(".tab-images .starterset-product").forEach((el) => {
      const slot = slotByVariant.get(String(el.dataset.product));
      if (slot) {
        el.dataset.slot = slot;
        el.classList.add("added");
      } else {
        delete el.dataset.slot;
        el.classList.remove("added");
      }
    });
  }

  /* -------------------------------
     Pick animation — the design flies from its grid tile into the tray slot
  -------------------------------- */
  const FLY_MS = 420;
  const STEPS = 24;

  const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  function reducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  // Scale-in on the slot, marking the moment the design lands. Re-added on every fill,
  // so the class is stripped first to restart the animation on an already-used slot.
  function popSlot(slot) {
    slot.classList.remove("slot-landed");
    void slot.offsetWidth;
    slot.classList.add("slot-landed");
    slot.addEventListener("animationend", () => slot.classList.remove("slot-landed"), {
      once: true,
    });
  }

  // Animates a copy of the chosen design from its grid tile into the tray slot it just
  // filled.
  //
  // The clone is a copy of the tile's own <img>, so it reuses the already-decoded image
  // and cannot flash while the slot's full-size src loads.
  //
  // Tile and slot crop the same photo to different shapes (a near-square tile vs. a
  // portrait slot), so the clone morphs its cover-box — width/height — instead of using
  // transform: scale(). Scaling would have to squash one axis to reach the slot's
  // proportions and would visibly distort the nail; animating the box lets object-fit
  // re-crop each frame, so the nail keeps its shape the whole way down.
  //
  // Centres follow a quadratic bezier lifted above the straight line, so the design arcs
  // up out of the grid and drops into the tray rather than sliding flatly across it.
  function flyToSlot(fromRect, slot, tileImg) {
    const host = OVERLAY?.querySelector(".content");
    const slotImg = slot?.querySelector("img");
    if (!host || !slotImg || !fromRect || !fromRect.width) return;

    if (reducedMotion() || typeof host.animate !== "function") {
      popSlot(slot);
      return;
    }

    const toRect = slotImg.getBoundingClientRect();
    if (!toRect.width) return;

    const hostRect = host.getBoundingClientRect();
    const from = {
      x: fromRect.left - hostRect.left,
      y: fromRect.top - hostRect.top,
      w: fromRect.width,
      h: fromRect.height,
    };
    const to = {
      x: toRect.left - hostRect.left,
      y: toRect.top - hostRect.top,
      w: toRect.width,
      h: toRect.height,
    };

    const clone = tileImg.cloneNode(true);
    clone.removeAttribute("loading");
    clone.alt = "";

    const el = document.createElement("div");
    el.className = "nails-fly";
    el.style.left = `${from.x}px`;
    el.style.top = `${from.y}px`;
    el.style.width = `${from.w}px`;
    el.style.height = `${from.h}px`;
    el.appendChild(clone);
    host.appendChild(el);

    // The slot's own image stays hidden until the clone lands on it, so the design reads
    // as arriving in one place instead of being in two at once.
    slot.classList.add("slot-incoming");

    const fc = { x: from.x + from.w / 2, y: from.y + from.h / 2 };
    const tc = { x: to.x + to.w / 2, y: to.y + to.h / 2 };
    const lift = Math.min(80, Math.abs(tc.y - fc.y) * 0.28);
    const ctrl = { x: fc.x + (tc.x - fc.x) * 0.4, y: fc.y + (tc.y - fc.y) * 0.4 - lift };

    // Easing is baked into the sampled frames, so the animation itself runs linear.
    const frames = [];
    for (let i = 0; i <= STEPS; i++) {
      const t = i / STEPS;
      const p = easeInOutCubic(t);
      const q = 1 - p;
      const cx = q * q * fc.x + 2 * q * p * ctrl.x + p * p * tc.x;
      const cy = q * q * fc.y + 2 * q * p * ctrl.y + p * p * tc.y;

      // Size settles ahead of position: the design shrinks as it leaves the grid rather
      // than staying tile-sized and collapsing on arrival.
      const s = easeOutCubic(t);
      const w = from.w + (to.w - from.w) * s;
      const h = from.h + (to.h - from.h) * s;

      frames.push({
        offset: t,
        width: `${w}px`,
        height: `${h}px`,
        transform: `translate(${cx - w / 2 - from.x}px, ${cy - h / 2 - from.y}px)`,
      });
    }

    const anim = el.animate(frames, { duration: FLY_MS, easing: "linear" });

    // Land on finish; also on cancel, so a torn-down animation can never strand the
    // slot's image hidden.
    const land = () => {
      el.remove();
      slot.classList.remove("slot-incoming");
      popSlot(slot);
    };
    anim.addEventListener("finish", land, { once: true });
    anim.addEventListener("cancel", land, { once: true });
  }

  /* -------------------------------
     Remove selection (close icon)
  -------------------------------- */

  // Writes one slot to match `product`, or back to its empty placeholder when there is
  // no product for it. data-image / data-option-title are the slot's own "empty" values,
  // rendered by Liquid, so a cleared slot restores exactly what it started as.
  function applySlot(slot, index, product) {
    slot.dataset.index = index;

    const imgEl = slot.querySelector("img");
    const p = slot.closest(".chooseColor-wrapper")?.querySelector("p");

    if (product) {
      // Only overlay slots carry .filled — updateProgress and adjustPrice count on it
      // meaning "a filled slot in the overlay", so the main wrapper must not add it.
      slot.classList.add("coladded");
      if (slot.closest("#nailsoverlay")) slot.classList.add("filled");

      slot.dataset.exist = "true";
      slot.dataset.price = product.price;
      slot.dataset.variant = product.variant;

      if (imgEl) imgEl.src = product.image;
      if (p) p.innerText = limitWords(product.title);
      return;
    }

    slot.classList.remove("coladded", "filled");
    slot.removeAttribute("data-exist");
    slot.removeAttribute("data-variant");
    slot.removeAttribute("data-price");

    if (imgEl) imgEl.src = slot.dataset.image;
    if (p) p.innerText = slot.dataset.optionTitle || "";
  }

  // Rebuilds every picker from productDATA, keeping the chosen designs packed into the
  // lowest slots and dropping surplus boxes.
  //
  // The "extra design" boxes appendBox() creates were never taken away again: removing a
  // design only blanked its box, so adding five extras and changing your mind left five
  // empty boxes behind, each still wearing a -15% flag. The Liquid-rendered base slots
  // stay as placeholders; anything past them only exists while a design occupies it.
  //
  // Boxes are appended in index order, so DOM order is index order and pruning from the
  // tail keeps the -15% flag on exactly the boxes past the base count. Slots are
  // renumbered as they are written, since data-index addresses productDATA (index - 1)
  // and is sent to the cart as _set_index — it cannot be left with holes in it.
  function compactSlots() {
    const chosen = productDATA.filter(Boolean);
    const total = Math.max(getMinDesigns(), chosen.length);

    document.querySelectorAll(".colorModel-wrapper").forEach((wrapper) => {
      [...wrapper.querySelectorAll("[data-index]")].forEach((slot, i) => {
        if (i >= total) {
          slot.closest(".chooseColor-wrapper")?.remove();
          return;
        }
        applySlot(slot, i + 1, chosen[i]);
      });
    });

    productDATA = [];
    for (let i = 0; i < total; i++) productDATA[i] = chosen[i] || null;
  }

  function removeByIndex(selectedIndex) {
    ensureProductDataLength();

    if (productDATA[selectedIndex - 1]) {
      productDATA[selectedIndex - 1] = null;
    }

    compactSlots();
    syncTabBadges();

    checkLimit();
    requestAnimationFrame(() => {
      updateProgress();
      adjustPrice();
      updateCartButtonText();
    });
  }

  function getSlotPrice(item) {
    const value = String(item?.dataset?.price || "0").replaceAll(",", "").replaceAll(".", "");
    const price = parseFloat(value);
    return Number.isFinite(price) ? price : 0;
  }

  function updateDisplayedPrices(currentPrice, compareAt) {
    if (typeof formatMoney !== "function") return;

    const priceHtml = formatMoney(currentPrice);
    const compareHtml = compareAt > currentPrice ? formatMoney(compareAt) : "";

    $$("[data-product-price-list]").forEach((priceList) => {
      const priceNode = $(".price--highlight,.price--large", priceList);
      if (priceNode) priceNode.innerHTML = priceHtml;

      const compareNode = $(".price--compare", priceList);
      if (compareNode) {
        compareNode.innerHTML = compareHtml;
        compareNode.style.display = compareHtml ? "" : "none";
      }
    });

    $$(".msticky__price").forEach((priceNode) => {
      priceNode.innerHTML = compareHtml
        ? `<span class="msticky__was">${compareHtml}</span> ${priceHtml}`
        : priceHtml;
    });
  }

  /* -------------------------------
     Price logic (your original, but faster)
  -------------------------------- */
  function adjustPrice() {
    ensureProductDataLength();

    // grid toggle same as original
    if (productDATA.filter(Boolean).length > 2) {
      DOM.mainWrapper?.classList.add("two-grid");
    } else {
      DOM.mainWrapper?.classList.remove("two-grid");
    }

    const basePrice = parseFloat(productPriceMeta.price) || 0;
    const baseCompareAt = parseFloat(productPriceMeta.compareAt) || basePrice;
    let currentPrice = basePrice;
    let compareAt = baseCompareAt;
    let paidExtraPrice = 0;
    let paidExtraCompareAt = 0;

    // We must follow your DOM-based pricing because you store per-slot price in DOM.
    // We'll loop filled elements once.
    const filledEls = $$("#nailsoverlay div.filled");

    filledEls.forEach((item) => {
      const raw = getSlotPrice(item);

      if (pageFlags.isStarterSpecialBundle) {
        const d = raw * 0.1;
        currentPrice += (raw - d);
        compareAt += raw;
        const u = $(".unfilled");
        if (u) u.innerText = productDATA.filter(Boolean).length < 3 ? productDATA.filter(Boolean).length : "4";
        return;
      }

      if (pageFlags.isStarterSpecialBigBundle) {
        const d = raw * 0.2;
        currentPrice += (raw - d);
        compareAt += raw;
        const u = $(".unfilled");
        if (u) u.innerText = productDATA.filter(Boolean).length < 7 ? productDATA.filter(Boolean).length : "8";
        return;
      }

      if (pageFlags.isSpecialBundle) {
        // First 5 designs are included in the starterset base price.
        if (!["1", "2", "3", "4", "5"].includes(String(item.dataset.index))) {
          const d = raw * 0.15;
          paidExtraPrice += (raw - d);
          paidExtraCompareAt += raw;
        }

        const u = $(".unfilled");
        if (u) u.innerText = Math.min(productDATA.filter(Boolean).length, 5).toString();
        return;
      }

      // promoted vs normal
      if (pageFlags.isPromotedProduct) {
        if (!["1", "2", "3"].includes(String(item.dataset.index))) {
          const d = raw * 0.15;
          paidExtraPrice += (raw - d);
          paidExtraCompareAt += raw;
        }
      } else {
        if (!["1", "2"].includes(String(item.dataset.index))) {
          const d = raw * 0.15;
          paidExtraPrice += (raw - d);
          paidExtraCompareAt += raw;
        }
      }

      const u = $(".unfilled");
      if (u) u.innerText = Math.min(productDATA.filter(Boolean).length, pageFlags.isPromotedProduct ? 4 : 3).toString();
    });

    if (pageFlags.isSpecialBundle || pageFlags.isStarterSet || pageFlags.isPromotedProduct) {
      currentPrice = basePrice + paidExtraPrice;
      compareAt = paidExtraCompareAt > 0 ? basePrice + paidExtraCompareAt : baseCompareAt;
    }

    updateDisplayedPrices(currentPrice, compareAt);
  }

  /* -------------------------------
     Add multiple items to cart (your original)
  -------------------------------- */
  async function addMultipleItemsToShopifyCart(items) {
    if (pageFlags.isStarterSpecialBigBundle || pageFlags.isStarterSpecialBundle) {
      window.isOutsideEurope = false;
    }

    const cartUrl = "/cart/add.js";
    const requestBody = {
      items,
      attributes: window.isOutsideEurope
        ? { _bundle_enable: "true", _bundle_version: "v2" }
        : { _bundle_enable: "false", _bundle_version: "v0" },
    };

    const response = await fetch(cartUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) throw new Error(await response.text());

    const data = await response.json();

    const cartToggle = document.querySelector('.header__linklist [aria-controls="mini-cart"]');
    if (cartToggle) cartToggle.click();

    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));

    return data;
  }

  async function removeProductsBySetId(setId) {
    const cartRes = await fetch("/cart.json");
    if (!cartRes.ok) throw new Error(`HTTP error! Status: ${cartRes.status}`);
    const cartData = await cartRes.json();

    const itemsToDelete = cartData.items.filter((item) => item.properties && item.properties["_set_id"] == setId);
    const updates = {};
    itemsToDelete.forEach((item) => (updates[item.key] = 0));

    const updateRes = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    });

    if (!updateRes.ok) throw new Error(`HTTP error! Status: ${updateRes.status}`);

    const result = await updateRes.json();
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    return result;
  }

  /* -------------------------------
     Add to cart click (full original behavior preserved)
  -------------------------------- */
  function attachCartButtonHandlers() {
    if (!cartButtons.length) return;

    cartButtons.forEach((btn) => {
      btn.addEventListener("click", async function (event) {
        event.preventDefault();
        event.stopPropagation();

        // remove existing set in url
        if (location.href.includes("set_id")) {
          const setID = new URL(location.href).searchParams.get("set_id");
          if (setID) await removeProductsBySetId(setID);
        }

        ensureProductDataLength();
        const filteredProducts = productDATA.filter(Boolean);

        // gate: if not enough, force chooseColor click like original
        const required = getRequiredCountForATC();
        if (filteredProducts.length < required) {
          const chooser = document.querySelector(".chooseColor");
          if (chooser) chooser.click();
          return;
        }

        // default product data like original
        const form = document.querySelector(".shopify-product-form");
        const quantitySelector = document.querySelector("quantity-selector");
        const defaultProductquantity = quantitySelector?.querySelector('[name="quantity"]')?.value || 1;

        let setId = (Math.random() * 100).toFixed(2);

        let defaultProduct = {
          id: productPriceMeta.variantID,
          quantity: defaultProductquantity,
          properties: {
            "_parent-product": true,
            _set_id: setId,
          },
        };

        if (document.querySelector(".template--product-special-bundle")) {
          defaultProduct.properties["_bundle-addon-big"] = true;
        }
        if (pageFlags.isPromotedProduct) {
          defaultProduct.properties["_bundle-addon-special"] = true;
        }
        if (pageFlags.isStarterSpecialBigBundle) {
          defaultProduct.properties["_bundle-special-big-addon-bundle"] = true;
        }
        if (pageFlags.isStarterSpecialBundle) {
          defaultProduct.properties["_bundle-special-addon-bundle"] = true;
        }

        let itemsToAdd = [];
        let loopIndex = 0;

        const freeAllowance = getFreeAllowance();
        const tempItems = [];

        for (const product of filteredProducts) {
          loopIndex++;

          const variantEl = document.querySelector('[data-variant="' + product.variant + '"]');
          if (!variantEl) continue;

          const variantIndex = variantEl.dataset.index;

          const variantObject = {
            id: product.variant,
            quantity: 1,
            properties: {
              "_bundled-product": true,
              _set_index: variantIndex,
              _loop_index: loopIndex,
              _set_id: setId,
            },
          };

          // bundle flags same as original
          if (pageFlags.isSpecialBundle) {
            variantObject.properties["_bundle-addon-big"] = true;
          } else if (pageFlags.isPromotedProduct) {
            variantObject.properties["_bundle-addon-special"] = true;
          }

          // FIRST PASS (index-based)
          let shouldBeFree = false;

          if (pageFlags.isSpecialBundle) {
            if (["1", "2", "3", "4", "5"].includes(String(variantIndex))) shouldBeFree = true;
          } else if (pageFlags.isPromotedProduct) {
            if (["1", "2", "3"].includes(String(variantIndex))) shouldBeFree = true;
          } else {
            if (["1", "2"].includes(String(variantIndex))) shouldBeFree = true;
          }

          if (shouldBeFree) {
            variantObject.properties.AddONFREE = true;
          } else {
            variantObject.properties.Addons = "Kit Product";
          }

          tempItems.push(variantObject);
        }

        // SECOND PASS (fallback fill)
        let freeCount = tempItems.filter((item) => item.properties.AddONFREE === true).length;

        if (freeCount < freeAllowance) {
          for (const item of tempItems) {
            if (freeCount >= freeAllowance) break;
            if (!item.properties.AddONFREE) {
              delete item.properties.Addons;
              item.properties.AddONFREE = true;
              freeCount++;
            }
          }
        }

        itemsToAdd.push(...tempItems);
        itemsToAdd.push(defaultProduct);

        // gates exactly like your original
        if (pageFlags.isStarterSpecialBigBundle || pageFlags.isStarterSpecialBundle) {
          if (pageFlags.isStarterSpecialBigBundle) {
            if (itemsToAdd.length > 8) addMultipleItemsToShopifyCart(itemsToAdd);
            else document.querySelector(".chooseColor")?.click();
          }
          if (pageFlags.isStarterSpecialBundle) {
            if (itemsToAdd.length > 4) addMultipleItemsToShopifyCart(itemsToAdd);
            else document.querySelector(".chooseColor")?.click();
          }
          return;
        }

        if (pageFlags.isSpecialBundle) {
          if (itemsToAdd.length >= 6) addMultipleItemsToShopifyCart(itemsToAdd);
          else document.querySelector(".chooseColor")?.click();
        } else {
          if (pageFlags.isPromotedProduct) {
            if (itemsToAdd.length >= 4) addMultipleItemsToShopifyCart(itemsToAdd);
            else document.querySelector(".chooseColor")?.click();
          } else {
            if (itemsToAdd.length >= 3) addMultipleItemsToShopifyCart(itemsToAdd);
            else document.querySelector(".chooseColor")?.click();
          }
        }
      });
    });
  }

  /* -------------------------------
     Restore from set_id (your original)
  -------------------------------- */
  async function fetchCart() {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: { _bundle_enable: "false", _bundle_version: "0" },
      }),
    });

    const cart = await fetch("/cart.json");
    return await cart.json();
  }

  async function checkIfSetExist() {
    if (!location.href.includes("set_id")) return;

    const setID = new URL(location.href).searchParams.get("set_id");
    if (!setID) return;

    const cartObject = await fetchCart();
    const cartItems = cartObject.items || [];

    // pick items matching set, excluding parent product
    const temp = cartItems.filter((item) => {
      const props = item.properties || {};
      return !props["_parent-product"] && props["_set_id"] == setID;
    });

    // sort by _loop_index exactly like your original
    const productsToDisplayFromCart = [];
    for (let i = 1; i <= temp.length; i++) {
      for (let j = 0; j < temp.length; j++) {
        if (String(temp[j].properties["_loop_index"]) === String(i)) {
          productsToDisplayFromCart.push(temp[j]);
        }
      }
    }

    // ensure enough boxes
    productsToDisplayFromCart.forEach((item) => {
      const loopIndex = Number(item.properties["_loop_index"]);
      while (currentSlotCount() < loopIndex) {
        if (!checkLimit()) break;
        appendBox();
      }
    });

    ensureProductDataLength();

    // fill slots based on loop order (your original)
    productsToDisplayFromCart.forEach((item) => {
      const index = Number(item.properties["_loop_index"]);
      const image = item.featured_image?.url;
      const variant = item.variant_id;
      const price = item.price;
      const title = item.product_title;

      const productHASH = {
        index,
        image,
        variant,
        price,
        title,
      };

      // fill the exact slot index (not first empty)
      const slot = $(`#nailsoverlay [data-index="${index}"]`);
      if (slot && !slot.dataset.exist) {
        productDATA[index - 1] = productHASH;

        slot.classList.add("coladded", "filled");
        slot.dataset.exist = "true";
        slot.dataset.price = price;
        slot.dataset.variant = variant;

        const imgEl = slot.querySelector("img");
        if (imgEl) imgEl.src = image;

        const p = slot.closest(".chooseColor-wrapper")?.querySelector("p");
        if (p) p.innerText = limitWords(title);

        // mirror into main slot if exists
        if (DOM.mainWrapper) {
          const mainSlot = DOM.mainWrapper.querySelector(`[data-index="${index}"]`);
          if (mainSlot && !mainSlot.dataset.exist) {
            mainSlot.classList.add("coladded");
            mainSlot.dataset.exist = "true";
            mainSlot.dataset.price = price;
            mainSlot.dataset.variant = variant;

            const msImg = mainSlot.querySelector("img");
            if (msImg) msImg.src = image;

            const mp = mainSlot.closest(".chooseColor-wrapper")?.querySelector("p");
            if (mp) mp.innerText = limitWords(title);
          }
        }

        syncTabBadges();
      }
    });

    requestAnimationFrame(() => {
      updateProgress();
      adjustPrice();
      updateCartButtonText();
    });
  }

  /* -------------------------------
     Slider click (your original)
  -------------------------------- */
  function attachSlider() {
    if (!DOM.slider) return;

    DOM.slider.querySelectorAll(".slide").forEach((slide) => {
      slide.addEventListener("click", function () {
        if (this.classList.contains("active")) return;

        DOM.slider.querySelectorAll(".slide.active").forEach((a) => a.classList.remove("active"));
        this.classList.add("active");

        const collectionID = this.dataset.collectionId;
        const collectionTab = document.querySelector(`[data-tab-id="${collectionID}"]`);
        if (!collectionTab) return;

        const open = document.querySelector(".tab-images:not(.hidden)");
        if (open) open.classList.add("hidden");
        collectionTab.classList.remove("hidden");
      });
    });
  }

  /* -------------------------------
     Click handling (FAST + COMPLETE)
  -------------------------------- */
  document.addEventListener("click", function (e) {
    // remove from bundle in cart drawer (your original)
  
    const bundleRemove = e.target.closest(".bundeled-products-remove");
    if (bundleRemove) {
     
      const setId = bundleRemove.dataset.setId;
      if (setId) removeProductsBySetId(setId);
      return;
    }

    // close icon in slots
    const closeBtn = e.target.closest(".close_icon_svg");
    if (closeBtn) {
      const selectedIndex = closeBtn.closest("[data-index]")?.dataset.index;
      if (!selectedIndex) return;
      removeByIndex(Number(selectedIndex));
      return;
    }

    // click a product tile
    const productTile = e.target.closest(".starterset-product");
    if (productTile) {
      const index = productTile.closest("[data-index]")?.dataset.index;
      const image = productTile.dataset.image;
      const variant = productTile.dataset.product;
      const price = productTile.dataset.price;
      const title = productTile.dataset.title;

      if (!checkLimit()) return;

      // mark tile as added
      productTile.classList.add("added");

      const productHASH = { index, image, variant, price, title };

      // Measure the tile before the fill, while it is still the thing the customer
      // pressed — appending a slot below can reflow the tray.
      const tileImg = productTile.querySelector("img");
      const fromRect = tileImg?.getBoundingClientRect();

      // if all are filled/coladded -> append box then fill
      if (allSlotsAreColadded()) {
        if (checkLimit()) appendBox();
      }

      // fill first empty slot (this is your intended behavior)
      const filledSlot = fillFirstEmptySlot(productHASH);

      if (filledSlot && tileImg) {
        // The tray scrolls horizontally, so bring the slot into view before measuring it
        // — otherwise the design flies to where the slot is about to be.
        filledSlot.scrollIntoView({ block: "nearest", inline: "nearest" });
        flyToSlot(fromRect, filledSlot, tileImg);
      }

      // update again
      checkLimit();
      return;
    }

    // add-in-overlay button
    const addOverlay = e.target.closest(".add-in-overlay");
    if (addOverlay) {
      if (checkLimit()) appendBox();
    }
  });

  /* -------------------------------
     Initial setup
  -------------------------------- */
  // make the first chooseColor active like original
  const firstChoose = document.querySelector("#nailsoverlay .colorModel-wrapper .chooseColor");
  if (firstChoose) firstChoose.classList.add("active");

  // set initial button label like original
  cartButtons.forEach((btn) => {
    const cartTxt = document.querySelector("[data-atc-text]");
    const label = cartTxt ? cartTxt.getAttribute("data-atc-text") : t("chooseColors", "Choose your colors");
    const node = btn.querySelector(".loader-button__text") || btn.querySelector("span");
    if (node) node.innerHTML = label;
    btn.disabled = false;
  });

  attachSlider();
  attachCartButtonHandlers();
  ensureProductDataLength();
  updateProgress();
  updateCartButtonText();

  // restore if set_id is present
  checkIfSetExist();
})();
